import { L1ClipboardCopyButton, useClipboardCopy } from "./L1ClipboardCopyButton"

interface L3ClipboardCopyButtonProps {
	data: string|null
}

export const L3ClipboardCopyButton = ({data}: L3ClipboardCopyButtonProps) => {
	const { showSuccess, handleClick } = useClipboardCopy(data)
	if(!data) {
		return null
	}
	return (
		<L1ClipboardCopyButton
			showSuccess={showSuccess}
			onClick={handleClick}
		/>
	)
}
